/**
 * Created by Jerker Nord on 2023-10-24.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Loner} from "../Loner";
import {AlarmClockFont} from "../fonts/AlarmClockFont";
import {LonerGameMode} from "../server/LonerGameMode";
import {gsap} from "gsap"
import {NLCText} from "@nolimitcity/slot-launcher/bin/display/NLCText";
import {LonerGameAssets} from "../LonerGameAssets";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";

export class LonerLogoView extends PIXI.Container implements StageLayer {

    private static LOGO_POSITION:PIXI.Point = new PIXI.Point(320, 32);

    private _logoImage:PIXI.Sprite;
    private _hideTL:gsap.core.Timeline;
    private _showTL:gsap.core.Timeline;
    private _flickerTL:gsap.core.Timeline;

    constructor() {
        super();
        this.name = "LonerLogoView";
        this.init();
    }

    private init():void {
        this._logoImage = new PIXI.Sprite(Loner.assetLoader.getTextures(LonerGameAssets.VHS_LOGO)[0]);
        this._logoImage.position = LonerLogoView.LOGO_POSITION;
        this.addChild(this._logoImage);

        if(Loner.model.data.mode == LonerGameMode.FEATURE_PIN_THE_WIN) {
            this.visible = false;
        }

        this._showTL = gsap.timeline({paused : true});
        this._showTL.add(() => {
            this.alpha = 0;
            this.visible = true;
        });
        this._showTL.add(gsap.to(this, {duration : 0.3, alpha : 1}));

        this._hideTL = gsap.timeline({paused : true});
        this._hideTL.add(gsap.to(this, {duration : 0.2, alpha : 0}));
        this._hideTL.add(() => {
            this.visible = false;
        });

        this._flickerTL = gsap.timeline({repeat:-1});
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.03, 2)}));
        this._flickerTL.add(() => {
            this._logoImage.alpha = MathHelper.randomNumberInRange(0.7, 0.8, 2);
        });
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.02, 2)}));
        this._flickerTL.add(() => {
            this._logoImage.alpha = MathHelper.randomNumberInRange(0.7, 0.8, 2);
        });
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.03, 2)}));
        this._flickerTL.add(() => {
            this._logoImage.alpha = MathHelper.randomNumberInRange(0.7, 0.8, 2);
        });
    }

    public hide():void {
        if(this._showTL.isActive()) {
            this._showTL.pause();
        }
        this._hideTL.restart();
    }

    public show():void {
        if(this._hideTL.isActive()) {
            this._hideTL.pause();
        }
        this._showTL.restart();
    }
}